module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuMDIyOTMgMTZMMyA5SDBWNkgzVjRDMyAxLjMwMDggNC42NzE1MSAwIDcuMDc5MzggMEM4LjIzMjc3IDAgOS4yMjQwNiAwLjA4NTg3IDkuNTEyOTQgMC4xMjQyNVYyLjk0NTA3TDcuODQyOTYgMi45NDU4M0M2LjUzMzQzIDIuOTQ1ODMgNi4yNzk4NyAzLjU2ODEgNi4yNzk4NyA0LjQ4MTI0VjZIMTBMOSA5SDYuMjc5ODZWMTZIMy4wMjI5M1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook-xcon.svg
// module id = 1454
// module chunks = 180